var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowToggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.525 5.475L14.025 9.975C14.325 10.275 14.325 10.725 14.025 11.025C13.725 11.325 13.275 11.325 12.975 11.025L9 7.05L5.025 11.025C4.725 11.325 4.275 11.325 3.975 11.025C3.825 10.875 3.75 10.725 3.75 10.5C3.75 10.275 3.825 10.125 3.975 9.975L8.475 5.475C8.775 5.175 9.225 5.175 9.525 5.475Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowToggle);
export default __webpack_public_path__ + "static/media/arrow-toggle.75e8f16ad97b0f740f8474a786580a42.svg";
export { ForwardRef as ReactComponent };